import { render, staticRenderFns } from "./custom-form-cell.vue?vue&type=template&id=80bac3ec&scoped=true"
import script from "./custom-form-cell.vue?vue&type=script&lang=js"
export * from "./custom-form-cell.vue?vue&type=script&lang=js"
import style0 from "./custom-form-cell.vue?vue&type=style&index=0&id=80bac3ec&prod&scoped=true&lang=css"
import style1 from "./custom-form-cell.vue?vue&type=style&index=1&id=80bac3ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bac3ec",
  null
  
)

export default component.exports